const stringToCode = string => {
    const ascii = a => a.charCodeAt(0);

    return string
        .split("")
        .map(ascii)
        .join("");
};

export const getFileWithEncodedName = (file, type = "image/*") => {
    const fileNameEncoded = stringToCode(file.name || "");
    const blob = file?.slice(0, file.size, "image/png");
    return new File([blob], fileNameEncoded, {type});
};
